import * as Sentry from '@sentry/react';

export const initializeSentry = (dsn: string | undefined, optedOut: boolean): boolean => {
  if (!dsn || optedOut) return false;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'production',
    release: process.env.REACT_APP_BUILD_ID,
    tracesSampleRate: 0.1,
    ignoreErrors: [
      'A listener indicated an asynchronous response by returning true, but the message channel closed before a response was received',
    ],
  });
  return true;
};
